import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card_container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "main_text" }

import defaultImg from '@/assets/themeFour/noData4.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'noDataCustom',
  props: {
    imgSrc: {
        type: String,
        default: defaultImg
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.imgSrc,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.noData')), 1)
  ]))
}
}

})